import styled, { css } from 'styled-components';
import { I as IconButton } from '../IconButton/IconButton-B-_fri-k.js';
import { B as Button } from '../Button-Cwlb3sfd.js';

const StyledMainButton = /*#__PURE__*/styled(Button).withConfig({
  componentId: "sc-storm-ui-40026394__sc-m59f18-0"
})(["margin-inline-end:", ";border-start-start-radius:6px;border-start-end-radius:", ";border-end-start-radius:6px;border-end-end-radius:", ";", " ", ";"], ({
  theme
}) => theme.spacing.xxxxsmall.default, ({
  theme
}) => theme.border.radius.square, ({
  theme
}) => theme.border.radius.square, ({
  $small
}) => $small && css(["border-start-start-radius:4px;border-start-end-radius:", ";border-end-start-radius:4px;border-end-end-radius:", ";"], ({
  theme
}) => theme.border.radius.square, ({
  theme
}) => theme.border.radius.square), ({
  $fullWidth
}) => $fullWidth && css(["flex-grow:1;"]));
const StyledMenuButton = /*#__PURE__*/styled(IconButton).withConfig({
  componentId: "sc-storm-ui-40026394__sc-m59f18-1"
})(["height:inherit;border-start-start-radius:", ";border-start-end-radius:6px;border-end-start-radius:", ";border-end-end-radius:6px;", " display:flex;flex-direction:row;flex-wrap:nowrap;justify-content:center;align-content:center;align-items:center;"], ({
  theme
}) => theme.border.radius.square, ({
  theme
}) => theme.border.radius.square, ({
  $small
}) => $small && css(["border-start-start-radius:", ";border-start-end-radius:4px;border-end-start-radius:", ";border-end-end-radius:4px;"], ({
  theme
}) => theme.border.radius.square, ({
  theme
}) => theme.border.radius.square));
const ButtonGroupFrame = /*#__PURE__*/styled('div').withConfig({
  componentId: "sc-storm-ui-40026394__sc-m59f18-2"
})(["display:inline-flex;> *:not(:first-child){margin-inline-end:0;margin-inline-start:0;}"]);
const SplitButtonWrapper = /*#__PURE__*/styled('div').withConfig({
  componentId: "sc-storm-ui-40026394__sc-m59f18-3"
})(["width:fit-content;"]);

export { ButtonGroupFrame as B, SplitButtonWrapper as S, StyledMainButton as a, StyledMenuButton as b };
//# sourceMappingURL=SplitButton.styles-CbOpu2i-.js.map
